exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/auth/accept-terms/accept-terms.component.scss
// module id = ../../../../../src/app/auth/accept-terms/accept-terms.component.scss
// module chunks = 2